// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3idRb","card":"Cards_card__kTRB7","infected":"Cards_infected__buuYh","recovered":"Cards_recovered__32s49","deaths":"Cards_deaths__3iclB"};